import { useEffect, useMemo } from 'react';
import { useLocation, useMatch, useNavigate } from 'react-router-dom';
import { useSession } from '../useSession';
import { useQueryParams } from '../useQueryParams';
import { AppRoutes } from 'src/types';
import { REDIRECT_FROM, REFERRAL_ID } from 'src/constants';

export const useAuthRedirectForSpecialRoutes = () => {
  const { pathname, search } = useLocation();
  const navigate = useNavigate();
  const matchReferralLink = useMatch(AppRoutes.REFERRAL);

  const {
    searchParams: { task },
  } = useQueryParams();

  const shouldRedirect = useMemo(
    () => task || pathname === AppRoutes.PAYMENT || !!matchReferralLink,
    [task, pathname, matchReferralLink],
  );

  const { isOpenTier } = useSession();

  useEffect(() => {
    if (!isOpenTier || !shouldRedirect) {
      return;
    }
    if (isOpenTier) {
      if (!!matchReferralLink && !!matchReferralLink?.params?.referralCode) {
        localStorage.setItem(
          REFERRAL_ID,
          matchReferralLink?.params?.referralCode,
        );
        localStorage.setItem(REDIRECT_FROM, AppRoutes.PAYMENT);
        console.log(
          '[REDIRECT_FROM] set item and navigate to sign-up',
          AppRoutes.PAYMENT,
        );
        navigate(AppRoutes.SIGN_UP, { replace: true });
        return;
      }

      console.log(
        '[REDIRECT_FROM] set item and navigate to login',
        `${pathname}${search}`,
      );
      localStorage.setItem(REDIRECT_FROM, `${pathname}${search}`);
      navigate(AppRoutes.LOGIN, { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpenTier, navigate, shouldRedirect, matchReferralLink]);
};
